module.exports = __webpack_public_path__ + "img/FONDO3.52c335fc.jpg";